export default __webpack_public_path__ + "85113c273d030d3111e963d397bbfe14.png";